import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChange } from '@angular/core';
import { JuvenileCase } from './../../../juvenile/juvenile-case';
import { PartyAttorney } from '../../../juvenile/juvenile-case-sections/party-attorney';

@Component({
  selector: 'app-juvenile',
  templateUrl: './juvenile.component.html',
  styleUrls: ['./../juvenile-case-view.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class JuvenileComponent implements OnChanges {

  @Input() juvenileCase: JuvenileCase;
  partyAttorneys: PartyAttorney[];

  constructor() {}

  ngOnChanges(changes: { [propName: string]: SimpleChange}) {
    if (this.juvenileCase &&
      this.juvenileCase.getJuvenile()) {
      this.partyAttorneys = this.juvenileCase.getJuvenile().getPartyAttorneyList()
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/juvenile/juvenile.component.ts